(() => {
  if (window.fujiShoppingContextReady) return;
  window.fujiShoppingContextReady = true;
  const sourceKey = 'fuji:shopping-source:v1';
  const returnKey = 'fuji:shopping-return:v1';
  const lifetime = 30 * 60 * 1000;
  const root = new URL(document.currentScript?.dataset.root || '/', location.origin).pathname.replace(/\/?$/, '/');
  let pageProduct = productHandle(location.href);

  function listingURL(value) {
    try {
      const url = new URL(value, location.origin);
      if (url.origin !== location.origin || url.username || url.password || !url.pathname.startsWith(root)) return null;
      const path = url.pathname.slice(root.length);
      if (!/^collections\/[^/]+(?:\/[^/]+)?\/?$/.test(path) && path !== 'search' && path !== 'search/') return null;
      if (path.startsWith('search') && url.searchParams.has('type') && !url.searchParams.get('type').split(',').map(value => value.trim()).includes('product')) return null;
      const clean = new URL(url.pathname, location.origin);
      for (const [key, item] of url.searchParams) {
        if (['q', 'type', 'view', 'sort_by', 'page', 'fuji_search', 'options[prefix]', 'options[unavailable_products]'].includes(key) || /^filter\.[a-zA-Z0-9_.-]+$/.test(key)) clean.searchParams.append(key, item);
      }
      return clean.pathname + clean.search;
    } catch { return null; }
  }

  function productHandle(value) {
    try {
      const url = new URL(value, location.origin);
      if (url.origin !== location.origin || !url.pathname.startsWith(root)) return null;
      return url.pathname.match(/\/products\/([^/]+)\/?$/)?.[1] || null;
    } catch { return null; }
  }

  function read(key) {
    try {
      const record = JSON.parse(sessionStorage.getItem(key));
      if (!record || !Number.isFinite(record.time) || Date.now() - record.time > lifetime || record.time > Date.now()) return null;
      const listing = listingURL(record.listing);
      if (!listing || !Number.isFinite(record.scrollY) || record.scrollY < 0 || record.scrollY > 1000000) return null;
      return { ...record, listing };
    } catch { return null; }
  }

  function save(key, record) {
    try { sessionStorage.setItem(key, JSON.stringify(record)); } catch { /* Optional navigation memory. */ }
  }

  function productSource(link) {
    const product = productHandle(link.dataset.productUrl || location.href);
    const record = read(sourceKey);
    if (product && (record?.viewedProduct || record?.product) === product) return record;
    const listing = document.referrer ? listingURL(document.referrer) : null;
    return product && listing ? { listing, product, scrollY: 0, time: Date.now() } : null;
  }

  function enhance(scope = document) {
    const currentProduct = productHandle(location.href);
    if (currentProduct !== pageProduct) {
      const record = read(sourceKey);
      if (currentProduct && pageProduct && (record?.viewedProduct || record?.product) === pageProduct) {
        save(sourceKey, { ...record, viewedProduct: currentProduct });
      }
      pageProduct = currentProduct;
    }
    const selector = '[data-fuji-shopping-return]';
    const links = scope.matches?.(selector) ? [scope] : scope.querySelectorAll(selector);
    links.forEach(link => {
      const record = link.dataset.fujiShoppingReturn === 'product' ? productSource(link) : read(sourceKey);
      if (!record) return;
      link.href = record.listing;
      link.hidden = false;
    });
  }

  document.addEventListener('click', event => {
    const link = event.target.closest?.('a[href]');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.hasAttribute('download')) return;
    if (link.dataset.fujiShoppingReturn) {
      const record = link.dataset.fujiShoppingReturn === 'product' ? productSource(link) : read(sourceKey);
      if (record && listingURL(link.href) === record.listing) save(returnKey, record);
      return;
    }
    if (!link.closest('#product-grid') || link.matches('.fuji-card-color[role="button"]') || link.target === '_blank') return;
    const listing = listingURL(location.href);
    const product = productHandle(link.href);
    if (listing && product) save(sourceKey, { listing, product, scrollY: Math.max(0, window.scrollY), time: Date.now() });
  }, true);

  function restore(event) {
    const record = read(returnKey);
    if (!record || listingURL(location.href) !== record.listing) return;
    try { sessionStorage.removeItem(returnKey); } catch { /* Native navigation remains available. */ }
    if (event?.persisted) return;
    requestAnimationFrame(() => {
      const links = [...document.querySelectorAll('#product-grid a[href]')].filter(item => productHandle(item.href) === record.product && !item.matches('.fuji-card-color'));
      const isVisible = item => {
        for (let node = item; node?.nodeType === 1; node = node.parentElement) {
          const style = window.getComputedStyle(node);
          if (node.hidden || style.display === 'none' || style.visibility === 'hidden') return false;
        }
        return true;
      };
      const link = links.find(item => item.id.startsWith('CardLink-') && isVisible(item)) || links.find(isVisible);
      link?.focus({ preventScroll: true });
      window.scrollTo({ top: record.scrollY, behavior: 'instant' });
    });
  }

  enhance();
  document.addEventListener('shopify:section:load', event => enhance(event.target));
  new MutationObserver(records => {
    const added = new Set();
    records.forEach(record => record.addedNodes.forEach(node => {
      if (node.nodeType === 1 && node.isConnected) added.add(node);
    }));
    added.forEach(node => {
      for (let parent = node.parentElement; parent; parent = parent.parentElement) {
        if (added.has(parent)) return;
      }
      enhance(node);
    });
  }).observe(document.body || document.documentElement, { childList: true, subtree: true });
  window.addEventListener('pageshow', restore);
  if (document.readyState === 'complete') restore();
})();
